import * as network from '../../pixelstreaming/network';
import { CanvasInfo } from '../base';
import * as webcad from '../../webcad';
import { BUILDING_TYPE_HOUSE } from '../../webcad/Constants';

class PSInteractiveView implements network.playerStatus {
  public viewElem: HTMLVideoElement;

  container: HTMLElement | null = null;

  // create canvas
  constructor(container) {
    // const { container } = ThreeView.get();
    this.container = container;

    this.createCanvas();
  }

  private createCanvas() {
    if (document.getElementById('psInteractiveElement')) {
      document.getElementById('psInteractiveElement').remove();
    }
    this.viewElem = document.createElement('video');
    this.viewElem.setAttribute('id', 'psInteractiveElement');
    this.container.prepend(this.viewElem);
    const { size } = CanvasInfo.get();
    this.viewElem.width = size.width;
    this.viewElem.height = size.height;
    this.showHide(false);
  }

  public onChange(status): void {
    if (status === network.statustype.connect) {
      if (!document.getElementById('psInteractiveElement')) this.createCanvas();
      this.showHide(true);
      this.showHideInteractiveViewMenu(true);
    }
    if (status === network.statustype.disconnect) {
      this.showHide(false);
      this.showHideInteractiveViewMenu(false);
    }
  }

  // show/hide canvas
  public showHide(show: boolean = true) {
    if (this.viewElem) this.viewElem.style.display = show ? 'block' : 'none';
  }

  public updateCanvasSize =() => {
    const { size } = CanvasInfo.get();
    this.viewElem.width = size.width;
    this.viewElem.height = size.height;
  }

  public showHideInteractiveViewMenu = (status: boolean = false) => {
    // 使用するUI切り替え
    const display = status ? 'none' : 'block'; // headerのファイルメニュー
    (document.querySelector('.for3D #headerMenuFile') as HTMLElement).style.display = display; // headerのファイルメニュー
    document.getElementById('btnCalculator').style.display = display; // headerの積算メニュー
    document.getElementById('headerMenuSetting').style.display = display; // headerの設定メニュー
    // document.getElementById('itemChangeMenuWrap').style.display = display; // 左メニュー
    (document.querySelector('#captureScreenshot .capt') as HTMLElement).style.display = display; // 撮影ボタン
    document.querySelectorAll('.for3D .changeApperanceBtnWrap .checkboxBtn').forEach((displayBtn: HTMLElement) => { displayBtn.style.display = display; }); // 外観の表示切り換えボタン
    webcad.WebCADGlobal.itemChangeMenuCategories3d.reset();
    document.querySelectorAll('.leftMenuCategories3D label').forEach((label: HTMLElement) => { label.style.display = display });
    // document.querySelectorAll('.for3D .oneFooterMenuLeft .floorBtnWrap').forEach((floorBtn: HTMLElement) => { floorBtn.style.display = display; }); // 階層切り替え
    (document.querySelector('.footerMenuMovieModeWrap') as HTMLElement).style.display = status ? 'flex' : 'none'; // 動画モード時のメニュー
    if (webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_HOUSE) {
      document.querySelector('.footerMenuMovieModeWrap').classList.remove('typeMansion');
      document.querySelector('.footerMenuMovieModeWrap').classList.add('typeHouse');
      (document.querySelector('.footerMenuMovieModeWrap .oneFooterMenuLeft') as HTMLElement).style.display = 'block';
    } else {
      document.querySelector('.footerMenuMovieModeWrap').classList.remove('typeHouse');
      document.querySelector('.footerMenuMovieModeWrap').classList.add('typeMansion');
      (document.querySelector('.footerMenuMovieModeWrap .oneFooterMenuLeft') as HTMLElement).style.display = 'none';
    }
  }
}
export default PSInteractiveView;
